export enum Conditions {
    Null = "",
    All = "全店舗",
    Group = "グループ",
    Store = "個店",
}
